"use client";
import PageContainer from "@/app/admin/_common/PageContainer";
import PageHeader from "@/app/admin/_common/PageHeader";
import CuoButton from "@/app/admin/_common/CuoButton";
import { usePerformersModel } from "./performersPageModel";
import PerformersToolbar from "./_cmp/PerformersToolbar";
import PerformerList from "./_cmp/PerformerList";
import PerformerListSkeleton from "./_cmp/PerformerListSkeleton";
import PerformerShowsDialog from "./_cmp/PerformerShowsDialog";
import { PerformerDialog } from "./_cmp/performerForm/PerformerDialog";
import { PlusCircle, Drama } from "lucide-react";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function PerformersPage() {
  const isMobile = useIsMobile();
  const {
    filteredPerformers,
    isLoading,
    search,
    setSearch,
    selectedPerformer,
    openForm,
    openCreateForm,
    openEditForm,
    closeForm,
    handleDelete,
    showsPerformer,
    openShows,
    closeShows,
    refetch,
  } = usePerformersModel();

  const addButton = (
    <CuoButton
      variant={isMobile ? "outline" : "default"}
      label={<span className="hidden sm:inline">Add performer</span>}
      icon={<PlusCircle className="size-3.5 shrink-0" size={14} />}
      onClick={openCreateForm}
      className="px-2 sm:px-3"
      aria-label="Add performer"
    />
  );

  const list = isLoading ? (
    <PerformerListSkeleton />
  ) : (
    <PerformerList
      performers={filteredPerformers}
      onEdit={openEditForm}
      onDelete={handleDelete}
      onViewShows={openShows}
    />
  );

  if (isMobile) {
    return (
      <PageContainer flush>
        <div className="flex h-full w-full flex-col overflow-y-auto">
          <div className="sticky top-0 z-10 flex flex-col gap-2 border-b border-border bg-card/80 px-3 py-2 backdrop-blur-sm">
            <PageHeader
              title="Performers"
              icon={Drama}
              subtitle={`${filteredPerformers.length} performers`}
              actions={addButton}
              className="static bg-transparent p-0 backdrop-blur-none"
            />
            <PerformersToolbar search={search} onSearchChange={setSearch} />
          </div>

          <div className="flex flex-1 flex-col pb-3">{list}</div>
        </div>

        <PerformerDialog
          open={openForm}
          defaultPerformer={selectedPerformer}
          onClose={closeForm}
          onSaved={refetch}
        />
        <PerformerShowsDialog performer={showsPerformer} onClose={closeShows} />
      </PageContainer>
    );
  }

  return (
    <PageContainer flush>
      <div className="flex h-full w-full flex-col">
        <PageHeader
          title="Performers"
          icon={Drama}
          subtitle={`${filteredPerformers.length} performers`}
          actions={addButton}
        />

        <div className="flex min-h-0 flex-1 flex-col gap-3 px-5 py-5">
          <PerformersToolbar search={search} onSearchChange={setSearch} />

          <div className="flex min-h-0 flex-1 flex-col">{list}</div>
        </div>
      </div>

      <PerformerDialog
        open={openForm}
        defaultPerformer={selectedPerformer}
        onClose={closeForm}
        onSaved={refetch}
      />
      <PerformerShowsDialog performer={showsPerformer} onClose={closeShows} />
    </PageContainer>
  );
}
